import React, { createContext, useContext, useLayoutEffect, useRef, useState } from 'react';
import { useUserStore } from '../../stores/userStore';
import { createSearchViewMemory } from './searchViewMemory';
const Context = createContext(null);
export function SearchViewMemoryProvider({ children }) {
  const scope = String(useUserStore((s) => s.user?.id) ?? 'guest');
  const ref = useRef(null);
  const [, update] = useState(0);
  if (!ref.current || ref.current.scope !== scope) {
    ref.current?.memory.clear();
    ref.current = { scope, memory: createSearchViewMemory() };
  }
  useLayoutEffect(
    () =>
      useUserStore.subscribe?.((state, previous) => {
        if (state.user?.id === previous.user?.id) return;
        ref.current.memory.clear();
        ref.current = {
          scope: String(state.user?.id ?? 'guest'),
          memory: createSearchViewMemory(),
        };
        update((n) => n + 1);
      }),
    [],
  );
  return <Context.Provider value={ref.current.memory}>{children}</Context.Provider>;
}
export function useSearchViewMemory() {
  const shared = useContext(Context);
  const local = useRef(null);
  if (!local.current) local.current = createSearchViewMemory();
  return shared || local.current;
}
